// Currency utility based on country
export const countryCurrencyMap = {
  'United States': { code: 'USD', symbol: '$' },
  'India': { code: 'INR', symbol: '₹' },
  'United Kingdom': { code: 'GBP', symbol: '£' },
  'Canada': { code: 'CAD', symbol: 'C$' },
  'Australia': { code: 'AUD', symbol: 'A$' },
  'Germany': { code: 'EUR', symbol: '€' },
  'France': { code: 'EUR', symbol: '€' },
  'Italy': { code: 'EUR', symbol: '€' },
  'Spain': { code: 'EUR', symbol: '€' },
  'Netherlands': { code: 'EUR', symbol: '€' },
  'Japan': { code: 'JPY', symbol: '¥' },
  'China': { code: 'CNY', symbol: '¥' },
  'Brazil': { code: 'BRL', symbol: 'R$' },
  'Mexico': { code: 'MXN', symbol: 'MX$' },
  'South Korea': { code: 'KRW', symbol: '₩' },
  'Russia': { code: 'RUB', symbol: '₽' },
  'South Africa': { code: 'ZAR', symbol: 'R' },
  'United Arab Emirates': { code: 'AED', symbol: 'د.إ' },
  'Saudi Arabia': { code: 'SAR', symbol: '﷼' },
  'Singapore': { code: 'SGD', symbol: 'S$' },
  'Hong Kong': { code: 'HKD', symbol: 'HK$' },
  'Switzerland': { code: 'CHF', symbol: 'CHF' },
  'Sweden': { code: 'SEK', symbol: 'kr' },
  'Norway': { code: 'NOK', symbol: 'kr' },
  'Denmark': { code: 'DKK', symbol: 'kr' },
  'Poland': { code: 'PLN', symbol: 'zł' },
  'Turkey': { code: 'TRY', symbol: '₺' },
  'Indonesia': { code: 'IDR', symbol: 'Rp' },
  'Malaysia': { code: 'MYR', symbol: 'RM' },
  'Thailand': { code: 'THB', symbol: '฿' },
  'Vietnam': { code: 'VND', symbol: '₫' },
  'Philippines': { code: 'PHP', symbol: '₱' },
  'Pakistan': { code: 'PKR', symbol: '₨' },
  'Bangladesh': { code: 'BDT', symbol: '৳' },
  'Nigeria': { code: 'NGN', symbol: '₦' },
  'Egypt': { code: 'EGP', symbol: 'E£' },
  'Israel': { code: 'ILS', symbol: '₪' },
  'New Zealand': { code: 'NZD', symbol: 'NZ$' },
  'Argentina': { code: 'ARS', symbol: 'AR$' },
  'Chile': { code: 'CLP', symbol: 'CL$' },
  'Colombia': { code: 'COP', symbol: 'CO$' },
  'Peru': { code: 'PEN', symbol: 'S/' },
};

// Default currency if country not found
const defaultCurrency = { code: 'USD', symbol: '$' };

export const getCurrencyByCountry = (country) => {
  if (!country) return defaultCurrency;
  return countryCurrencyMap[country] || defaultCurrency;
};

export const formatCurrency = (amount, country) => {
  if (amount === null || amount === undefined || amount === '' || amount === 0) {
    if (amount === 0) {
      const currency = getCurrencyByCountry(country);
      return `${currency.symbol}0`;
    }
    return '';
  }
  const currency = getCurrencyByCountry(country);
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '';
  
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.code,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(numAmount);
};

export const getCurrencySymbol = (country) => {
  return getCurrencyByCountry(country).symbol;
};

export const formatAmount = (amount, country) => {
  if (!amount && amount !== 0) return '';
  const currency = getCurrencyByCountry(country);
  const numAmount = parseFloat(amount);
  if (isNaN(numAmount)) return '';
  return `${currency.symbol}${numAmount.toLocaleString()}`;
};
